// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Co2B","title":"ClientReferral_title__3cM2o","itemText":"ClientReferral_itemText__3ymI2"};